var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSolMono = function SvgSolMono(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 398,
    height: 312,
    fill: "none",
    viewBox: "-48 -96 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M64.632 237.918a12.98 12.98 0 0 1 9.173-3.797h317.397c5.782 0 8.677 6.991 4.586 11.078l-62.717 62.667a12.97 12.97 0 0 1-9.172 3.798H6.501c-5.782 0-8.676-6.992-4.586-11.079zM64.632 3.797A12.98 12.98 0 0 1 73.805 0h317.397c5.782 0 8.677 6.992 4.586 11.079l-62.717 62.667a12.98 12.98 0 0 1-9.172 3.797H6.501c-5.782 0-8.676-6.992-4.586-11.079zM333.071 120.112a12.97 12.97 0 0 0-9.172-3.797H6.501c-5.782 0-8.676 6.991-4.586 11.078l62.717 62.667a12.98 12.98 0 0 0 9.173 3.798h317.397c5.782 0 8.677-6.992 4.586-11.079z"
  })));
};
export default SvgSolMono;